/**
 * Reports > Variety Decoding (user, 2026-10-15): the SP pair → variety table the arrivals decode
 * against, and the pairs still coded.
 */
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { downloadExport, withQuery } from "@/features/inventory/export";
import { api } from "@/lib/api-client";

const PATH = "/reports/sp-decode";

export const spDecodeSearch = z.object({
  cropId: z.coerce.number().int().positive().optional().catch(undefined),
  source: z.enum(["vnr_api", "manual"]).optional().catch(undefined),
  q: z.string().max(60).optional().catch(undefined),
});
export type SpDecodeSearch = z.infer<typeof spDecodeSearch>;

export interface SpDecodeRow {
  id: number;
  crop: string;
  spFemale: string;
  spMale: string;
  variety: string;
  source: "vnr_api" | "manual";
  newVariety: boolean;
  decodedAt: string;
  lots: number;
}
export interface SpCodedRow {
  crop: string;
  spFemale: string;
  spMale: string;
  lots: number;
  pendingFeedLots: number;
}
export interface SpDecodeReport {
  rows: SpDecodeRow[];
  coded: SpCodedRow[];
  crops: Array<{ id: number; name: string }>;
}

const params = (s: SpDecodeSearch) => ({
  cropId: s.cropId,
  source: s.source,
  q: s.q?.trim() || undefined,
});

export function useSpDecodeReport(s: SpDecodeSearch) {
  const p = params(s);
  return useQuery({
    queryKey: ["reports", "sp-decode", p],
    queryFn: () => api<SpDecodeReport>(withQuery(PATH, p)),
    placeholderData: keepPreviousData,
  });
}

export const spDecodeXlsx = (s: SpDecodeSearch) =>
  downloadExport(PATH, { ...params(s), format: "xlsx" }, "Variety-Decoding.xlsx");
